import { render, staticRenderFns } from "./ModalSidebar.vue?vue&type=template&id=5e02c00b&"
import script from "./ModalSidebar.vue?vue&type=script&lang=js&"
export * from "./ModalSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports